import { render } from "./edit-invoice.vue?vue&type=template&id=33d299c9&scoped=true"
import script from "./edit-invoice.vue?vue&type=script&lang=js"
export * from "./edit-invoice.vue?vue&type=script&lang=js"

import "./edit-invoice.vue?vue&type=style&index=0&id=33d299c9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d299c9"]])

export default __exports__